module.exports = __webpack_public_path__ + "static/12-b7e9657bdd253a6ee26131ea50b51d78.png";